/**
 * 입력한 값을 숫자로 변환 시킨다.
 */

export const getNumber = (value, isNumberOnly) => {
  const format = isNumberOnly ? /[^0-9]/gi : /[^0-9.-]/gi;
  const number = value ? Number(value.toString().replace(format, "")) : 0;
  return isNaN(number) ? 0 : number;
};

/**
 * 콤마가 추가된 숫자로 변환시킨다.
 */

export const getCommaNumber = (value) => {
  return String(getNumber(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/**
 * 퍼센트를 계산한다.
 */

export const getPercent = (a, b, fixedDigit) => {
  let p = (a * 100) / b;
  if (p < 0) p = 0;
  else if (p > 100) p = 100;
  p = fixedDigit ? Number(p.toFixed(fixedDigit)) : Math.round(p);
  return isNaN(p) ? 0 : p;
};

/**
 * 전화번호 형식으로 변환시킨다.
 */

export const getPhoneNumber = (value) => {
  const number = value.replace(/[^0-9]/gi, "");
  const getType = () => {
    const a = Number(number.substr(0, 1));
    const b = Number(number.substr(1, 1));
    const c = Number(number.substr(2, 1));
    const d = Number(number.substr(3, 1));
    if (a == 0 && b == 0 && c) return "global";
    if (a == 0 && 2 <= b && b <= 6 && 1 <= c && c <= 5) return "local";
    if (a == 0 && b == 8 && c) return "local";
    if (a == 0 && b == 1 && c) return "mobile";
    if (a == 0 && b && c == 0) return "internet";
    if (a == 1 && (b == 1 || b == 2 || b == 3 || b == 4 || b == 8) && c)
      return "reserve";
    if (a == 1 && 5 <= b && b <= 9 && c && d) return "company";
    return "";
  };
  const type = getType();
  const n = number.length;
  let countList = [];
  if (type == "global") {
    countList = [3, 3, -1];
  } else if (type == "local") {
    const y = Number(number.substr(1, 1));
    const z = Number(number.substr(2, 1));
    const i = y == 2 ? 2 : 1 <= z && z <= 5 ? 3 : 2;
    const j = n - i < 8 ? 3 : 4;
    countList = [i, j, 4];
  } else if (type == "company") {
    countList = [4, 4];
  } else {
    countList = [3, n == 10 ? 3 : 4, 4];
  }
  const numberList = [];
  let count = 0;
  countList.forEach((item, index) => {
    const value = number.substr(count, countList[index]);
    count += countList[index];
    if (value) numberList.push(value);
  });
  return numberList.join("-");
};

/**
 * 태그를 제외한 텍스트를 리턴시킨다.
 */

export const getTextContent = (value) => {
  const div = document.createElement("div");
  div.innerHTML = value;
  return div.textContent || div.innerText || "";
};

export default { getNumber, getCommaNumber, getPhoneNumber, getTextContent };

/**
 * 개수 만큼 '0'을 추가한다.
 */

String.prototype.zf = function (n) {
  let value = this;
  for (let i = 0; i < n; i++) value = "0" + value;
  return value.substr(value.length - n, n);
};

Number.prototype.zf = function (n) {
  return this.toString().zf(n);
};

/**
 * 개수 만큼 공백을 추가한다.
 */

String.prototype.sf = function (n) {
  let value = this;
  for (let i = 0; i < n; i++) value = " " + value;
  return value.substr(value.length - n, n);
};

Number.prototype.sf = function (n) {
  return this.toString().sf(n);
};

/**
 * 태그 및 예약된 문자를 변경한다.
 */

String.prototype.recoverTag = function () {
  return this.replace(/\&#60;/g, "<")
    .replace(/\&#62;/g, ">")
    .replace(/\&lt;/g, "<")
    .replace(/\&gt;/g, ">")
    .replace(/\&#47;/g, "/")
    .replace(/&#124;/g, "|");
};
String.prototype.replaceTag = function () {
  return this.replace(/\</g, "&#60;")
    .replace(/\>/g, "&#62;")
    .replace(/\//g, "&#47;")
    .replace(/\|/g, "&#124;");
};

export const firstCase = (value) => {
  const node = value.split(" ");
  for (let i = 0; i < node.length; i++)
    node[i] = node[i].charAt(0).toUpperCase() + node[i].slice(1).toLowerCase();
  return node.join(" ");
};

export const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const getPhoneNumberFormat = (phoneNumber) => {
  let numFormat = phoneNumber;
  if (!numFormat) return;

  // 가운데 3자리 휴대폰번호 처리
  if (numFormat[7] === "-") {
    if (numFormat.length === 13) return;
    if (numFormat.length === 8 && numFormat.slice(7, 8) === "-") {
      numFormat = `${numFormat.slice(0, 7)}-`;
      return numFormat;
    }
    return numFormat;
  }

  if (numFormat.length === 4 && numFormat[numFormat.length - 1] === "-") {
    return numFormat;
  }
  if (numFormat.length === 9 && numFormat[numFormat.length - 1] === "-") {
    return numFormat;
  }

  if (!/^\d+$/.test(numFormat[numFormat.length - 1].replace(/-/gi, ""))) {
    return;
  }
  if (numFormat.length === 4 && numFormat.slice(3, 4) !== "-") {
    numFormat = `${numFormat.slice(0, 3)}-${numFormat.slice(3, 4)}`;
    return numFormat;
  }
  if (numFormat.length === 9 && numFormat.slice(8, 9) !== "-") {
    numFormat = `${numFormat.slice(0, 8)}-${numFormat.slice(8, 9)}`;
    return numFormat;
  }
  if (numFormat.length === 4 && numFormat.slice(3, 4) === "-") {
    numFormat = `${numFormat.slice(0, 3)}`;
    return numFormat;
  }
  if (numFormat.length === 9 && numFormat.slice(8, 9) === "-") {
    numFormat = `${numFormat.slice(0, 8)}`;
    return numFormat;
  }

  return numFormat;
};

export const formatNumberToWonCurrency = (value) =>
  `₩${(value || 0).toLocaleString()}`;
